import { render, staticRenderFns } from "./Characteristics.vue?vue&type=template&id=f193867c&scoped=true"
import script from "./Characteristics.vue?vue&type=script&lang=js"
export * from "./Characteristics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f193867c",
  null
  
)

export default component.exports